<template>
  <div class="vacations-chart layout" style="padding-bottom: 50px !important">
    <vacation-modal ref="vacationModal" :can-edit="canEdit" @success="update" @remove="update"></vacation-modal>

    <remove-vacation-modal ref="removeVacationModal" @remove="update" />

    <div class="layout-header">
      <div class="layout-title">График отпусков и больничных</div>
      <div class="layout-header-actions">
        <div class="layout-header-action">
          <c-button2
            size="small"
            :icon="{
              icon: 'bookmark',
              activeColor: 'white',
            }"
            :tooltip="{
              text: 'Добавить в закладки',
              activeText: 'Убрать из закладок',
            }"
            active-color="blue"
            :active="bookmark"
            @click="bookmark = !bookmark"
          />
        </div>
        <div class="layout-header-action">
          <c-button2
            v-if="canEdit"
            :responsive="true"
            size="small"
            label="Добавить отпуск/больничный"
            color="primary"
            :icon="{ icon: 'plus', color: 'white' }"
            @click="addVacation"
          />
        </div>
      </div>
    </div>

    <div class="vacations-chart__content">
      <Loader v-if="!inited" :active="!inited" :height="300"></Loader>
      <div v-show="inited">
        <filters ref="filters" @apply="applyFilters" @inited="filtersInited = true"></filters>
        <vacations-chart
          ref="chart"
          :can-edit="canEdit"
          @click.native="chartClickHandler"
          @focus.native="onChartFocus"
          @addPeriod="addPeriod"
          @editPeriod="editPeriod"
          @inited="tableInited = true"
        ></vacations-chart>
      </div>
    </div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import moment from "moment";
import CButton2 from "@/components/controls2/Button";
import TopButton from "@/components/top-button";
import Filters from "./components/filters";
import VacationModal from "./components/vacation-modal";
import RemoveVacationModal from "./components/remove-vacation-modal";
import VacationsChart from "./components/table";
import Loader from "@/components/loader";

export default {
  components: {
    CButton2,
    TopButton,
    Filters,
    VacationModal,
    VacationsChart,
    RemoveVacationModal,
    Loader,
  },

  data() {
    return {
      canEdit: false,
      bookmark: false,
      filtersInited: false,
      tableInited: false,
    };
  },

  computed: {
    inited() {
      return this.filtersInited && this.tableInited;
    },
  },

  watch: {
    inited(v) {
      if (v) {
        const filters = this.$refs.filters.getParams();
        this.$nextTick(() => this.$refs.chart.update(filters));
      }
    },
  },

  created() {
    this.$store.dispatch("getUserPermissions").then((res) => {
      const permissions = res.response;

      this.canEdit = permissions.find((p) => p === "updateVacations" || p === "updateVacationsAll");
    });
  },

  methods: {
    chartClickHandler(e) {
      const { event } = e.target.dataset;
      const workerListComponent = this.$refs.chart.$refs.list;

      if (event === "add-period") {
        const { date, workerId } = e.target.dataset;
        const worker = workerListComponent.workers.find((w) => w.id.toString() === workerId);

        this.addPeriod({ start: date, worker });
      }
      if (event === "edit-period") {
        const { periodId, workerId } = e.target.dataset;
        const worker = workerListComponent.workers.find((w) => w.id.toString() === workerId);
        const vacation = worker.vacations.find((p) => p.id.toString() === periodId);
        this.editPeriod({ worker, vacation });
      }
    },
    addVacation() {
      this.$refs.vacationModal.open();
    },

    addPeriod(data) {
      this.$refs.vacationModal.open({
        start: moment(data.start).format("DD.MM.YYYY"),
        worker: data.worker,
      });
    },

    editPeriod({ worker, vacation }) {
      this.$refs.vacationModal.open({
        vacation,
        worker,
      });
      console.log({ worker, vacation })
    },

    removeVacation(period) {
      this.$refs.removeVacationModal.open(period);
    },

    applyFilters() {
      const filters = this.$refs.filters.getParams();
      this.$refs.filters.saveParams();
      this.$refs.chart.update(filters);
    },

    update() {
      this.$nextTick(() => this.applyFilters());
    },

    saveParams() {
      // let filters = this.$refs.filters.getFilterParams();
      // let query = {
      //   ...this.$route.query
      // };
      // this.$router
      //   .replace({
      //     name: "vacations-chart",
      //     query
      //   })
      //   .catch(() => {});
    },
  },
};
</script>
